import { Link } from 'react-router-dom';

export default function HeroAbout() {
  return (
    <section className="relative pt-32 pb-20 sm:pb-28 overflow-hidden bg-white">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.03]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'radial-gradient(circle, #f97316 1px, transparent 1px)',
            backgroundSize: '40px 40px',
          }}
        />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Photo */}
          <div className="flex-shrink-0">
            <div className="relative">
              <div className="w-56 h-56 sm:w-72 sm:h-72 rounded-3xl overflow-hidden shadow-2xl border-4 border-white ring-1 ring-gray-200">
                <img
                  src="https://media.licdn.com/dms/image/v2/D4E03AQHVp3NJxVCYiA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1718614827498?e=1753920000&v=beta&t=EvJqJqJqJqJqJqJqJqJqJqJqJqJqJqJqJqJqJqJqJqI"
                  alt="Marc Signorel - Expert Digital et Business"
                  title="Marc Signorel - Fondateur Usine à Leads"
                  className="w-full h-full object-cover object-top"
                  loading="eager"
                  fetchPriority="high"
                  decoding="async"
                  width="400"
                  height="400"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.src =
                      'https://public.readdy.ai/ai/img_res/604582e635ace71bfe0f2dcbafa7e546.jpg';
                  }}
                />
              </div>
              {/* Decorative accent */}
              <div className="absolute -bottom-3 -right-3 w-20 h-20 bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl -z-10" />
              <div className="absolute -top-3 -left-3 w-16 h-16 bg-gradient-to-br from-teal-400 to-teal-500 rounded-xl -z-10 opacity-60" />
            </div>
          </div>

          {/* Text content */}
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-orange-50 border border-orange-200 text-orange-700 text-sm font-medium px-4 py-2 rounded-full mb-6">
              <i className="ri-user-star-line" />
              <span>Votre interlocuteur</span>
            </div>

            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 mb-4 leading-tight">
              <a href="https://www.linkedin.com/in/marcsignorel/" target="_blank" rel="noopener noreferrer nofollow">Marc Signorel</a>
            </h1>
            <p className="text-xl sm:text-2xl text-orange-600 font-semibold mb-6">
              Expert Digital &amp; Business — 20 ans d\u2019exp\u00e9rience
            </p>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed max-w-2xl">
              Je ne suis pas un th\u00e9oricien du digital. J\u2019ai dirig\u00e9 des \u00e9quipes, lanc\u00e9 des produits, pilot\u00e9 des P&amp;L et g\u00e9n\u00e9r\u00e9 du chiffre d\u2019affaires. <strong>Mon approche est 100\u00a0% orient\u00e9e r\u00e9sultats</strong>, parce que je comprends vos enjeux business avant de parler technologie.
            </p>

            {/* Quick links */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-8">
              <Link
                to="/"
                className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-3 rounded-lg font-semibold text-sm hover:from-orange-600 hover:to-orange-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-arrow-left-line" />
                Retour au site
              </Link>
              <a
                href="https://www.linkedin.com/in/marcsignorel/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="border-2 border-gray-200 text-gray-700 px-6 py-3 rounded-lg font-semibold text-sm hover:border-orange-300 hover:text-orange-600 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-linkedin-fill" />
                Voir mon LinkedIn
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
